export const ROLLING_RESTART_TIMEOUT = 1800000; // 30 minutes
